// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Payer } from "./Payer.ts";

export const adHocSelfPayEntryPointTypeEnum = {
  AD_HOC_SELF_PAY: "AD_HOC_SELF_PAY",
} as const;

export type AdHocSelfPayEntryPointTypeEnumKey =
  (typeof adHocSelfPayEntryPointTypeEnum)[keyof typeof adHocSelfPayEntryPointTypeEnum];

export const adHocSelfPayTypeEnum = {
  VANCE_AD_HOC_SELF_PAY: "VANCE_AD_HOC_SELF_PAY",
} as const;

export type AdHocSelfPayTypeEnumKey =
  (typeof adHocSelfPayTypeEnum)[keyof typeof adHocSelfPayTypeEnum];

export type AdHocSelfPay = {
  /**
   * @type string
   */
  entryPointType: AdHocSelfPayEntryPointTypeEnumKey;
  /**
   * @type string
   */
  memberId: string;
  /**
   * @description The workspace\'s default Medicaid payer used for this enrollment.
   */
  payer: Payer;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: AdHocSelfPayTypeEnumKey;
  /**
   * @type string
   */
  workspaceId: string;
};
